export default __webpack_public_path__ + "static/media/cells-logo.36152c8d.svg";